import { useFlightStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreFlightsComponent } from "@b2bportal/core-types";
import { useDeviceType } from "@b2bportal/core-utilities";
import { useI18nContext } from "@hopper-b2b/i18n";
import defaultStyles from "./CalendarPicker.module.scss";

export interface CalendarPickerBottomContentProps {
  priceTagsElement?: JSX.Element | null;
  ready?: boolean;
  onClose?: () => void;
  onSearch?: () => void;
  showApplyButton?: boolean;
}

export const CalendarPickerBottomContent = (
  props: CalendarPickerBottomContentProps
) => {
  const { t } = useI18nContext();
  const COMPONENT_KEY = CoreFlightsComponent.CalendarPicker;
  const styles = useFlightStyles(COMPONENT_KEY, defaultStyles);
  const [, cn] = useModuleBEM(styles, COMPONENT_KEY);
  const { priceTagsElement, onClose, onSearch, showApplyButton = true } = props;
  const ready = props.ready ?? true;

  const { isDesktopAndUp } = useDeviceType();

  return isDesktopAndUp || showApplyButton ? (
    <div className={cn("bottom-content")}>
      <div className={cn("price-tags-section")}>{priceTagsElement}</div>

      <button
        type="button"
        onClick={onClose}
        disabled={!ready}
        className={cn("apply-button")}
      >
        {t("continue")}
      </button>
    </div>
  ) : (
    <button
      type="button"
      className={cn("search-button")}
      onClick={onSearch}
      disabled={!ready}
    >
      {t("core-flights.search.dateSelection.chooseDates")}
    </button>
  );
};
